import DragComboListCategory from './DragComboListCategory.vue';
import DragComboList from './DragComboList.vue';
import DragCombo from './DragCombo.vue';

export default {
  DragComboListCategory,
  DragComboList,
  DragCombo,
};
